import type { AxiosInstance, AxiosRequestConfig } from 'axios'

interface IHttpRequestConfig extends AxiosRequestConfig {
  retry?: number
  retryMessageIgnoreList?: string[]
}
interface IHttpService {
  get<T>(url: string, data?: object): Promise<T>
  post<T>(url: string, data?: object | string, config?: IHttpRequestConfig ): Promise<T>
  abortRequests(): void
}
class HttpService implements IHttpService {
  private $fetch: AxiosInstance
  private $abortController: AbortController

  constructor(fetcher: AxiosInstance) {
    this.$fetch = fetcher
    this.$abortController = new AbortController()
  }

  async get<T>(url: string, data?: object): Promise<T> {
    return (await this.$fetch.get(url, {
      ...data,
      signal: this.$abortController?.signal,
    })) as T
  }

  async post<T>(url: string, data?: object | string, config?: IHttpRequestConfig ): Promise<T> {
    return (await this.$fetch.post(url, data, {
      signal: this.$abortController?.signal,
      ...config,
    })) as T
  }

  abortRequests() {
    this.$abortController?.abort()
    this.$abortController = new AbortController()
  }
}

export default HttpService
